import { Directive, HostBinding } from "@angular/core";

import { NgClassType, NgStyleType } from "../types";
import { MedLayoutService } from "../services/med-layout.service";

const STICKY_CONTENT_CLASS = "med-layout__bottom";

@Directive({
  selector: "[med-sticky-bottom-content]",
})
export class MedStickyBottomContentDirective {
  constructor(private layoutSvc: MedLayoutService) { }

  @HostBinding("class") get class(): NgClassType {
    return [STICKY_CONTENT_CLASS];
  }

  @HostBinding("style") get style(): NgStyleType {
    return {
      width: this.layoutSvc.contentWidth,
      left: this.layoutSvc.offsetLeft,
      bottom: this.layoutSvc.offsetBottom,
    };
  }
}
